import React, { PureComponent } from 'react';
import {
    MDTButton,
    IconSet,
    MDTAnchor,
    MDTSelect,
    MDTTextarea,
    successToast,
    errorToast,
} from 'mdt-core-components';
import { MDTApi } from 'mdt-core-components/src/services/mdtapi';
import { sendEventTrackingData } from 'mdt-core-components/src/helpers/commonUtils';
import { get } from 'lodash';
import './needhelps.css';

class MDTNeedHelps extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            submitEnable: false,
            needHelpsComments: '',
            reason: '',
            reasonList: [],
            reasonContactNumber: '',
            availableText: '',
        };
    }

    componentDidMount() {
        const country = get(this.props, 'userDetails.addresses[0].country.isoCode', 'US');
        this.callReasonsAPI(country);
        this.fetchReasonContactNumber(country);
    }

    fetchReasonContactNumber = (country) => {
        MDTApi.call(
            'api.cmsForms.fieldsets',
            {
                method: 'GET',
                successCallback: this.setReasonContactNumber,
                errorCallback: () => {},
            },
            { country, fieldsetsId: 'reasonContactNumber' }
        );
    };

    setReasonContactNumber = (data) => {
        const reasonContactNumber = get(data, 'fields[0].name', '');
        const availableText = get(data, 'fields[0].translationKey', 'available24by7');
        this.setState({ reasonContactNumber, availableText });
    };

    callReasonsAPI = (country) => {
        const params = { country };
        MDTApi.call('api.contactUs.reasons', {
            method: 'GET',
            params,
            successCallback: this.handleResponseData,
            errorCallback: this.handleResponseError,
        });
    };

    handleResponseData = (result) => {
        const { t } = this.props;
        const reasonData = [];
        if (result.fields && result.fields.length > 0) {
            for (let index = 0; index < result.fields.length; index++) {
                const obj = {
                    id: result.fields[index].id,
                    name: result.fields[index].name,
                    translationKey: t(result.fields[index].translationKey),
                };
                reasonData.push(obj);
            }
        }
        this.setState({ reasonList: reasonData });
    };

    handleResponseError = () => {
        this.setState({ reason: '', reasonList: [] });
    };

    handleSubmit = () => {
        const { email, lastName, firstName } = this.props.userDetails;
        const country = get(this.props, 'userDetails.addresses[0].country.isoCode', 'US');
        const submitObject = {
            firstName,
            lastName,
            email,
            country,
            comments: this.state.needHelpsComments,
            reason: this.state.reason,
        };
        MDTApi.call('api.contactUs.sendEmail', {
            method: 'POST',
            data: submitObject,
            successCallback: this.handleSubmitResponseData,
            errorCallback: this.handleSubmitResponseError,
        });
    };

    handleSubmitResponseData = () => {
        successToast(t('needHelpsSubmitSuccess'));
        this.clearEmailForm();
        // tracking event for dataanalytics
        const pageName = this.props.page;
        const eventParamObj = {
            eventCategory: 'Help',
            eventAction: pageName,
            processActions: false,
            eventLabel: 'submit',
        };
        sendEventTrackingData(eventParamObj);
        this.props.toggle(false, true);
    };

    handleSubmitResponseError = () => {
        errorToast(t('needHelpsSubmitError'), {
            autoClose: false,
        });
        this.clearEmailForm();
    };

    setReasonValues = (reason) => {
        this.setState({ reason });
    };

    clearEmailForm = () => {
        this.setState({ needHelpsComments: '', reason: '' });
    };

    onChangeComments = (val) => {
        this.setState({ submitEnable: !!val });
    };

    onBlurComments = (val) => {
        this.setState({ needHelpsComments: val });
    };

    render() {
        const { t, isOpen, toggle } = this.props;
        const {
            submitEnable,
            needHelpsComments,
            reason,
            reasonList,
            reasonContactNumber,
            availableText,
        } = this.state;
        const commentsProps = {
            name: 'needhelps-comment',
            onChange: this.onChangeComments,
            onBlur: this.onBlurComments,
            label: 'comments',
            value: needHelpsComments,
        };
        const reasonProps = {
            label: t('reason'),
            clearable: true,
            name: 'reason-list',
            labelKey: 'translationKey',
            valueKey: 'name',
            value: reason,
            options: reasonList,
            placeholder: t('select'),
            onChange: this.setReasonValues,
            updateValueOnLoad: true,
        };
        const clearBtnProps = {
            label: t('clear'),
            className: 'primaryLink transparent',
            onClick: this.clearEmailForm,
            disabled: !reason && !submitEnable,
        };
        const submitBtnProps = {
            label: t('submit'),
            className: 'primaryLink',
            onClick: this.handleSubmit,
            disabled: !reason || !submitEnable,
        };
        return (
            <div>
                <div className={`needhelps-container ${isOpen ? 'open' : 'closed'}`}>
                    <div className='needhelps-wrapper'>
                        <div className='needhelps-layer'>
                            <div className='opener'>
                                <div className='opener-wrapper'>
                                    <IconSet name='Help' />
                                </div>
                            </div>
                            <div className='needhelps-message-container'>
                                <MDTAnchor
                                    onClick={() => toggle(false)}
                                    className='close-needhelps'
                                >
                                    {' '}
                                    <IconSet name='cross1' />{' '}
                                </MDTAnchor>
                                <div className='needhelps-message body1'>
                                    <span className='mr-3'>
                                        <IconSet name='mail' />
                                    </span>
                                    <span>{t('emailUs')}</span>
                                </div>
                                <div className='reason-list mt-4'>
                                    <MDTSelect {...reasonProps} />
                                </div>
                                <div className='comments-sec mt-4'>
                                    <MDTTextarea {...commentsProps} />
                                </div>
                                <div className='button-wrappers text-right mt-4'>
                                    <span className='mr-4'>
                                        <MDTButton {...clearBtnProps} />
                                    </span>
                                    <MDTButton {...submitBtnProps} />
                                </div>
                            </div>
                            <div className='needhhelps-call-details'>
                                <div className=''>
                                    <span className='mr-3'>
                                        <IconSet name='phone' />
                                    </span>
                                    <span className='body1'>{t('callUs')}</span>
                                </div>
                                <div className='mt-2 help-text-sec'>
                                    <div className='text-sec body1'>{t(availableText)}</div>
                                    <div className='phone-sec body1 contact-no'>
                                        {reasonContactNumber}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MDTNeedHelps;
